import { createSlice, isRejectedWithValue } from '@reduxjs/toolkit';
import {
	fetchChatUnreadCount,
	getConversationList,
	getFullChat,
	sendChatFile,
	sendChatMessage,
} from './chatActions';

const initialState = {
	chats: [],
	currentChat: null,
	files: [],
	unreadCount: 0,
	loading: false,
	error: null,
	success: false,
};

const chatSlice = createSlice({
	name: 'chat',
	initialState,
	reducers: {
		setCurrentChat: (state, action) => {
			state.currentChat = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder
		.addCase(getConversationList.fulfilled, (state, action) => {
			state.chats = action.payload;
		})
		.addCase(getFullChat.fulfilled, (state, action) => {
			state.currentChat = action.payload;
			state.files = action.payload.messages.filter(m => m.isFile)
		})
		.addCase(fetchChatUnreadCount.fulfilled, (state, action) => {
			state.unreadCount = action.payload;
		})
		.addCase(sendChatFile.fulfilled, (state, action) => {
			if(action.payload.isFile)
				state.files.unshift(action.payload);
		}).addMatcher(
			isRejectedWithValue,
			(state, action) => {
				state.loading = false;
				state.error = action.payload || 'Something went wrong';
			}
		);


	},
});

export default chatSlice.reducer;

export const { setCurrentChat } = chatSlice.actions;
